import React, { Component, Dispatch } from 'react';
import { LoginService } from '../../api/login-service';
import { Common } from '../../core/common';
import { IAction, IAppState, IAuthInformation } from '../../models/action/core';
import { Log } from 'ng2-logger';
import { connect } from 'react-redux';
import { IEdevletLoginProps, IExternalLoginProps, ILoginAfterProps } from '../../models/pages/login';
import * as Actions from '../../store/actions/login';
import { Redirect } from 'react-router-dom';
import { UserType } from '../../models/enums/userType';

let _loginService: LoginService;
let _common: Common;
const _logger = Log.create('edevlet-login.tsx');

export class EdevletLogin extends React.Component<IEdevletLoginProps, any> {

    constructor(props: IEdevletLoginProps) {
        super(props);
        _loginService = new LoginService();
        _common = new Common();
    }
    componentDidMount() {
        
        const urlString = window.location.href;
        const url = new URL(urlString);
        const queryStringToken = url.searchParams.toString();
        
        this.props.dispatch(Actions.clickEdevletLogin(queryStringToken!));
    }

    public render() {
        let redirectRoot;
        if (this.props.isLogin) {
            redirectRoot = <Redirect to={this.props.userType !== UserType.Admin ? window.appSettings.DEFAULT_URL + '/u/Home/Index' : window.appSettings.DEFAULT_URL + '/u/Home/Cockpit'} />;
        }
        return (
            <div >
                {/* {redirectRoot} */}
            </ div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IEdevletLoginProps): any => {
    if (!state) {
        return state;
    }

    const returnProps: IEdevletLoginProps = Object.assign({}, ownProps, {
        isLogin: state.login.identitiy.isLogin,
        userType: state.login.identitiy.userType
    });
    return returnProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const CEdevletLogin = connect(
    mapStateToProps,
    dispatchProps
)(EdevletLogin);

export default CEdevletLogin;

